<template>
  <div class="cards clearfix">
    <!-- 今日 -->
    <Card
      v-loading="loading"
      class="card"
    >
      <div class="card-title">今日消耗额/元</div>
      <div class="card-money">
        <ICountUp
          class="card-money-normal"
          :endVal="today_cost"
          :options="countUpOptions"
        />
      </div>
      <div class="card-rate">
        <span>活跃账户数：</span>
        <span
          class="card-rate-value"
        >
          {{ todayaca }}
        </span>
      </div>
      <div class="card-footer">
        <div style="font-size: 12px">
          <span>今日消耗占直客总消耗的比例：</span>
          <span class="card-todaycr">{{ todaycr }}</span>
        </div>
        <!-- <div
          class="card-detail"
          @click="handleDetailClick('today')"
        >
          <i class="crm-icon-details" />
        </div> -->
      </div>
    </Card>

    <!-- 昨日 -->
    <Card
      v-loading="loading"
      class="card"
    >
      <div class="card-title">昨日消耗额/元</div>
      <div class="card-money">
        <ICountUp
          class="card-money-normal"
          :endVal="yestd_cost"
          :options="countUpOptions"
        />
      </div>
      <div class="card-rate">
        <span>日环比：</span>
        <span
          :class="{
            'card-rate-value': true,
            [`card-rate-${checkRiseOrFall(yestdar)}`]: true,
          }"
        >
          {{ yestdar }}
        </span>
        <i 
          :class="{
            'crm-icon-go-up': checkRiseOrFall(yestdar) === 'rise',
            'crm-icon-go-down': checkRiseOrFall(yestdar) === 'fall',
            [`card-rate-${checkRiseOrFall(yestdar)}`]: true,
          }"
        />
      </div>
      <div class="card-yesterday-footer">
        <Rank
          v-if="yestdtrk"
          text="昨日团队消耗额："
          :rank="yestdtrk"
        />
        <div
          v-else
          class="card-placeholder"
        />
        <div
          class="card-detail"
          @click="handleDetailClick('yesterday')"
        >
          <i class="crm-icon-details" />
        </div>
      </div>
    </Card>

    <!-- 本周 -->
    <Card
      v-loading="loading"
      class="card"
    >
      <Badge
        class="card-badge"
        :complete="checkIsCompletion(weekcmplr)"
      />
      <div class="card-title">
        本周消耗额/元
        <Popover
          width="400"
          trigger="hover"
        >
          本周消耗：<br>
          时间进度：{{ week_timepror }}，算法：(当周当前天数/当周总天数)*100%<br>
          消耗完成度：{{ week_costcmplr }}，(MTD消耗/当周目标消耗)*100%<br>
          业绩完成度：{{ weekcmplr }}，算法：(消耗完成度/时间进度)*100%<br>
          <br>
          注意：<br>
          1、如周跨月，按照上月每天应消耗金额的*周跨上月天数，加上本月每天应消耗金额*周跨本月天数
          <i
            slot="reference"
            style="color: #9ca6c0; margin-left: 6px; cursor: pointer;"
            class="el-icon-question"
          />
        </Popover>
      </div>
      <div class="card-money">
        <ICountUp
          :class="{
            'card-money-normal': true,
            'card-money-overfulfil': getCompletion(weekcmplr) === 1
          }"
          :endVal="week_cost"
          :options="countUpOptions"
        />
        <span
          :class="{
            'card-money-percent': true,
            'card-money-overfulfil': getCompletion(weekcmplr) === 1,
          }"
        >
          {{ overfulfilText(weekcmplr) }}
          {{ getOverfulfil(weekcmplr) }}
        </span>
      </div>
      <Progress
        class="card-progress"
        :percent="parseFloat(weekcmplr)"
        :overfulfil="getCompletion(weekcmplr) === 1"
      />
      <span class="card-target">
        目标金额：{{ week_target | currencyMoney }}
      </span>
      <div class="card-footer">
        <Rank
          v-if="weektrk"
          text="本周团队消耗额："
          :rank="weektrk"
        />
        <div
          v-else
          class="card-placeholder"
        />
        <div
          class="card-detail"
          @click="handleDetailClick('thisWeek')"
        >
          <i class="crm-icon-details" />
        </div>
      </div>
    </Card>

    <!-- 本月 -->
    <Card
      v-loading="loading"
      class="card"
    >
      <Badge
        class="card-badge"
        :complete="checkIsCompletion(percmplr)"
      />
      <div class="card-title">
        本月消耗额/元
        <Popover
          width="400"
          content="content"
          trigger="hover"
        >
          本月消耗：<br>
          时间进度：{{ month_timepror }}，算法：(当月当前天数/当月总天数)*100%<br>
          消耗完成度：{{ month_costcmplr }}，(MTD消耗/当月目标消耗)*100%<br>
          <br>
          业绩完成度：{{ percmplr }}，算法：(消耗完成度/时间进度)*100%
          <i
            slot="reference"
            style="color: #9ca6c0; margin-left: 6px; cursor: pointer;"
            class="el-icon-question"
          />
        </Popover>
      </div>
      <div
        :class="{
          'card-money': true,
          'card-money-overfulfil': getCompletion(percmplr) === 1
        }"
      >
        <ICountUp
          :class="{
            'card-money-normal': true,
            'card-money-overfulfil': getCompletion(percmplr) === 1,
          }"
          :endVal="month_cost"
          :options="countUpOptions"
        />
        <span class="card-money-percent">
          {{ overfulfilText(percmplr) }}
          {{ getOverfulfil(percmplr) }}
        </span>
      </div>
      <Progress
        class="card-progress"
        :percent="parseFloat(percmplr)"
        :overfulfil="getCompletion(percmplr) === 1"
      />
      <span class="card-target">
        目标金额：{{ month_target | currencyMoney }}
      </span>
      <div class="card-footer">
        <Rank
          v-if="monthtrk"
          text="本月团队消耗额："
          :rank="monthtrk"
        />
        <div
          v-else
          class="card-placeholder"
        />
        <div
          class="card-detail"
          @click="handleDetailClick('thisMonth')"
        >
          <i class="crm-icon-details" />
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { Popover } from 'element-ui';
import ICountUp from 'vue-countup-v2';

import Card from '../Card/Index';
import Badge from '../Badge/Index';
import Progress from '../Progress/Index';
import Rank from '../Rank/Index';

import { checkRiseOrFall, converFenToYuan } from '@/common/util';

export default {
  components: {
    ICountUp,
    Popover,

    Card,
    Badge,
    Progress,
    Rank,
  },

  props: {
    performance: {
      type: Object,
      required: true,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      // 计数动画配置
      countUpOptions: {
        decimalPlaces: 2,
        useEasing: false,
        prefix: '￥',
      },
    };
  },

  computed: {
    // 今日消耗
    today_cost() {
      return converFenToYuan(this.performance.today_cost);
    },

    // 活跃账户数
    todayaca() {
      return this.performance.todayaca;
    },

    // 今日消耗占直客总消耗的比例
    todaycr() {
      return this.performance.todaycr;
    },

    // 昨日消耗
    yestd_cost() {
      return converFenToYuan(this.performance.yestd_cost);
    },

    // 昨日消耗环比
    yestdar() {
      return this.performance.yestdar || '-';
    },

    // 昨日团队排名
    yestdtrk() {
      return this.performance.yestdtrk;
    },

    // 本周消耗
    week_cost() {
      return converFenToYuan(this.performance.week_cost);
    },

    // 本周业绩完成度
    weekcmplr() {
      return this.performance.weekcmplr;
    },

    // 本周目标金额
    week_target() {
      return converFenToYuan(this.performance.week_target);
    },

    // 本周团队排名
    weektrk() {
      return this.performance.weektrk;
    },

    // 本周时间进度
    week_timepror() {
      return this.performance.week_timepror;
    },

    // 本周消耗完成度
    week_costcmplr() {
      return this.performance.week_costcmplr;
    },

    // 本月时间进度
    month_timepror() {
      return this.performance.month_timepror;
    },

    // 本月消耗完成度
    month_costcmplr() {
      return this.performance.month_costcmplr;
    },

    // 本月消耗
    month_cost() {
      return converFenToYuan(this.performance.month_cost);
    },

    // 本月业绩完成度
    percmplr() {
      return this.performance.percmplr;
    },

    // 本月目标金额
    month_target() {
      return converFenToYuan(this.performance.month_target);
    },

    // 本月团队排名
    monthtrk() {
      return this.performance.monthtrk;
    },
  },

  methods: {
    // 获取达成率
    // 1 超额
    // -1 未达成
    // 0 达成
    getCompletion(percent) {
      const num = percent ? parseFloat(percent) : 0;
      if (num > 100) {
        return 1;
      } else if (num < 100) {
        return -1;
      } else {
        return 0;
      }
    },

    // 判断是否达标
    checkIsCompletion(percent) {
      const res = this.getCompletion(percent);
      return res >= 0;
    },

    // 超额达标的值
    getOverfulfil(percent) {
      const res = this.getCompletion(percent);
      if (res === 1) {
        const num = parseFloat(percent);
        return `${(num - 100).toFixed(2)}%`;
      }
      return percent || '0%';
    },

    // 超额文案
    overfulfilText(percent) {
      const res = this.getCompletion(percent);
      return res === 1 ? '超额' : '已完成';
    },

    // 查看详情
    handleDetailClick(date) {
      this.$emit('show-detail', date);
    },

    checkRiseOrFall,
  },
};
</script>

<style lang="less" scoped>
.cards {
  margin-top: 30px;
}

.card {
  width: 262px;
  height: 184px;
  float: left;
  margin: 0 22px 22px 0;
  color: rgba(156, 166, 192, 1);
  overflow: hidden;
  position: relative;
  box-sizing: border-box;

  &-todaycr {
    color: @crm-primary-color;
  }

  &-badge {
    position: absolute;
    top: 11px;
    right: 26px;
  }

  &:last-child {
    margin-right: 0;
  }

  &-title {
    font-size: 14px;
    font-weight: 600;
    line-height: 14px;
  }

  &-money {
    height: 33px;
    border-top: 1px solid #f5f8f8;
    border-bottom: 1px solid #f5f8f8;
    margin-top: 12px;
    display: flex;
    align-items: center;
    font-weight: bold;

    &-normal {
      font-size: 24px;
      font-weight: bold;
      line-height: 30px;
      color: rgba(48, 49, 51, 1);
    }

    &-overfulfil {
      color: #ff0046;
    }

    &-percent {
      font-size: 12px;
      margin-left: 12px;
    }
  }

  &-rate {
    font-size: 12px;
    display: flex;
    align-items: center;
    margin-top: 19px;

    & > i {
      font-size: 24px;
      margin-left: 9px;
    }

    &-value {
      font-size: 24px;
      font-weight: 500;
      margin-left: 8px;
      color: @crm-primary-color;
    }

    &-rise {
      color: @crm-rise-color;
    }

    &-fall {
      color: @crm-fall-color;
    }
  }

  &-progress {
    margin-top: 18px;
  }

  &-target {
    margin-top: 8px;
    font-size: 12px;
  }

  &-yesterday-footer {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &-footer {
    display: flex;
    justify-content: space-between;
    margin-top: 18px;
    align-items: center;
  }

  &-placeholder {
    flex: 1;
  }

  &-detail {
    flex: 0 0 30px;
    height: 16px;
    background: rgba(231, 239, 247, 1);
    border-radius: 2px;
    cursor: pointer;
    text-align: center;
    line-height: 16px;
    color: #3d4451;

    &:hover {
      color: @crm-primary-color;
    }
  }
}
</style>